import React, { useState } from 'react';

import { Getter, Plugin } from '@devexpress/dx-react-core';
import { IntegratedSelection } from '@devexpress/dx-react-grid';
import { TableSelection } from '@devexpress/dx-react-grid-material-ui';
import TableCell from '@material-ui/core/TableCell';
import Checkbox from '@material-ui/core/Checkbox';
import useStyles from './style';

export const PatchedIntegratedSelection = ({
  rowSelectionEnabled,
  ...restProps
}) => {
  const [rows, setRows] = useState([]);

  return (
    <Plugin>
      <Getter
        name="rows"
        computed={props => {
          setRows(props.rows);
          return rows.filter(rowSelectionEnabled);
        }}
      />
      <IntegratedSelection {...restProps} />
      <Getter name="rows" computed={() => rows} />
    </Plugin>
  );
};

const PatchedTableSelectionCell = props => {
  const classes = useStyles();

  return (
    <TableCell padding="checkbox" className={classes.cell} {...props}>
      <Checkbox disabled className={classes.checkbox} />
    </TableCell>
  );
};

export const PatchedTableSelection = props => {
  const { rowSelectionEnabled, ...restProps } = props;

  const renderCellComponent = React.useCallback(
    cellProps => {
      return rowSelectionEnabled(cellProps.tableRow.row) ? (
        <TableSelection.Cell {...cellProps} />
      ) : (
        <PatchedTableSelectionCell {...cellProps} />
      );
    },
    [rowSelectionEnabled],
  );

  return <TableSelection cellComponent={renderCellComponent} {...restProps} />;
};
